import { booleanAttribute, ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImageComponent, LoadingContainerComponent } from 'common-ui';
import { CommonProductDetailsComponentBase } from '../../CommonProductDetailsComponentBase';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'ideal-product-vendor-logo',
  imports: [ImageComponent, RouterModule, LoadingContainerComponent, JsonPipe],
  templateUrl: './product-vendor-logo.component.html',
  styleUrl: './product-vendor-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.link-enabled]': 'enableShopLink()',
  },
})
export class ProductVendorLogoComponent extends CommonProductDetailsComponentBase {
  protected readonly vendor = computed(() => this.productDetails()?.vendor);
  protected readonly ready = computed(() => !this.productDetails.error() && !this.productDetails.loading() && !!this.productDetails());

  public readonly enableShopLink = input(false, { transform: booleanAttribute });
  protected readonly logoUrl = computed(() => this.vendor()?.logoUrl ?? undefined);

  protected readonly shopLink = computed(() => (this.vendor()?.hasShop ? ['/vendors', this.vendor()?.vendorNumber] : ['/products']));
  protected readonly shopLinkParams = computed(() => (this.vendor()?.hasShop ? {} : { ao: true, ven: this.vendor()?.vendorNumber }));
}
